module.exports = "/images/logo_generali.png?580181a8acdce61036409f7ef4fcc4e9";


//////////////////
// WEBPACK FOOTER
// ./resources/images/project-img/logo_generali.png
// module id = 39Pm
// module chunks = 1